export default "__VITE_ASSET__cf90370b__"